module.exports = __webpack_public_path__ + "static/media/speed-up-line.ee2fb135.svg";